module.exports = __webpack_public_path__ + "img/bg-dark4.9fdaf56e.jpg";